import CASH_7ELEVEN_IMG from '@/assets/images/Cash_MY/1-7eleven-img.png';
import CASH_99SPEEDMART_IMG from '@/assets/images/Cash_MY/99speedmart-img.png';
import CASH_KKMART_IMG from '@/assets/images/Cash_MY/kkmart-img.png';

export const CASH_MY_OPTIONS = [
  { code: 'CASH-711', name: '7-Eleven', image: CASH_7ELEVEN_IMG },
  { code: 'CASH-99', name: '99 Speedmart', image: CASH_99SPEEDMART_IMG },
  { code: 'CASH-KK', name: 'KK Mart', image: CASH_KKMART_IMG },
];
